<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.47 16.47">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <circle
          id="Ellipse_67"
          data-name="Ellipse 67"
          class="cls-1"
          cx="8.23"
          cy="8.23"
          r="7.86"
        />
        <g id="Group_299" data-name="Group 299">
          <path
            id="Path_73"
            data-name="Path 73"
            class="cls-2"
            d="M7.1,3a4.15,4.15,0,1,0,4.14,4.15h0A4.15,4.15,0,0,0,7.1,3Zm0,7.33A3.19,3.19,0,1,1,10.28,7.1,3.19,3.19,0,0,1,7.1,10.29Z"
          />
          <path
            id="Path_74"
            data-name="Path 74"
            class="cls-2"
            d="M11.14,12.87,8.87,10.41l1.4-1.3,2.27,2.46a1,1,0,0,1-.06,1.35h0A1,1,0,0,1,11.14,12.87Z"
          />
          <g id="Group_298" data-name="Group 298">
            <path
              id="Path_75"
              data-name="Path 75"
              class="cls-2"
              d="M8.84,7.11h0a.44.44,0,0,1-.44.43H7.53v.87a.43.43,0,0,1-.43.43h0a.44.44,0,0,1-.44-.43h0V7.54H5.79a.43.43,0,0,1-.43-.43h0a.44.44,0,0,1,.43-.44h.87V5.8a.44.44,0,0,1,.44-.43h0a.43.43,0,0,1,.43.43h0v.87H8.4a.44.44,0,0,1,.44.44Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1 {
  fill: #fff;
  stroke: #afafaf;
  stroke-miterlimit: 10;
  stroke-width: 0.75px;
}
.cls-2 {
  fill: #afafaf;
}
</style>
